export interface DropDownDisplayOption {
    filterId: number;
    parentFilterId?: number;
    id: number;
    name: string;
    selected: boolean;
    parentSelection: string;
    parameter: string;
}

export class DropDownItem {
    filterId: number;
    parentFilterId?: number;
    name: string;
    orderBy: number;
    isMaster: boolean;
    isSubEntry: boolean;
    displayOptions: DropDownDisplayOption[];
    show: boolean;
    selected: boolean;

    constructor(item?: DropDownItem) {
        if (item) {
            this.filterId = item.filterId;
            this.name = item.name;
            this.parentFilterId = item.parentFilterId;
            this.orderBy = item.orderBy;
            this.isMaster = item.isMaster;
            this.isSubEntry = item.isSubEntry;
            this.displayOptions = item.displayOptions;
            this.show = item.show;
            this.selected = item.selected;   
        }
    }

    get hasSelectedOption() {
        if (!this.displayOptions) {
            return false;
        }
        return this.displayOptions.filter(option => option.selected).length > 0;
    }
}


// WEBPACK FOOTER //
// ./src/app/client-core/dtos/dropdown.models.ts